import React, { Component } from 'react';
import { TextImage } from '../../templates';
import './styles.css';
import { withLanguageContext } from '../../../utils/LanguageContext';

type Props = {
    content: {
        solutionsPage: {
            FlightBriefing: {
                content: string;
                heading: string;
                imageToRight: boolean;
                buttonLabel: string;
                href: string;
                target: string;
                download: boolean
            }
        }
    }
};


/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} [example]
 *
 * @augments {Component<Props>}
 */
class FlightBriefingAppView extends Component<Props, {}> {
    render () {
        const {
            content,
            heading,
            imageToRight,
            buttonLabel,
            href,
            target,
            download
        } = this.props.content.solutionsPage.FlightBriefing;

        return (
            <TextImage
                {...{
                    content,
                    heading,
                    imageToRight,
                    buttonLabel,
                    href,
                    target,
                    download
                }}
                imageClassName='FlightBriefingAppView'
                className='DocBrowser'
            />
        );
    }
}

export default withLanguageContext(FlightBriefingAppView);
